import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView,{Message} from 'iview'
import VueTitle from 'vue-page-title'
// import uploder from 'webuploader'
import VueResource from 'vue-resource'
import 'iview/dist/styles/iview.css'
import { auth_key } from './config'

Vue.use(VueResource);
Vue.use(VueTitle,{router});
// Vue.use(uploder)
Vue.use(iView);
Vue.config.productionTip = false;

// 请求处理
Vue.http.interceptors.push(req => {
  // console.log(req.isSign)
  if(typeof req.isSign === 'boolean' && req.isSign){
    return '';
  }
  // 携带授权令牌
  req.headers.set('Authorization', sessionStorage.getItem(auth_key));
// console.log(sessionStorage.getItem(auth_key))

  return res => {
    let data = res.body;
    // 强制退出，前往登陆
    if (data.code === 1001) {
      // console.log(data);
      Message.warning({
        content: data.msg,
        duration: 1.8,
        onClose() {
          sessionStorage.removeItem(auth_key);
          router.push({name:'home'});
        }
      });
    }
  }
});

// 路由守卫
// router.beforeEach((to, form, next) => {
//   let auth = sessionStorage.getItem(auth_key)
//   // console.log(to)
//   // console.log(to.name)
//   // if (to.name === 'login') {
//   //   if (typeof auth === 'string') {
//   //     router.push({ name: 'home' })
//   //   } else {
//   //     next()
//   //   }
//   // } else {
//     if (typeof auth === 'string') {
//       next()
//     } else {
//       // console.log(auth)
//       if(to.name === 'home'){
//         next();
//         return
//       }
//       Message.error({
//         content:'令牌丢失,登录状态丢失'
//       })
//       router.push({ name: 'home' })
//     }
//   // }
// })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
